import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import api from "../../services/api.service.js";
import { Token } from "../../utils/localStorage.util";
import { AuthServices } from "../../services/auth.service";
import { isAccessTokenExpired } from "../../utils/session.util.js";
import { SESSION_EXPIRED_EVENT } from "../../utils/sessionEvents.js";
import { setNavigate } from "../../routes/routesAdm.js";
import { LoginContext } from "./LoginContext.js";
// WebSocket desativado — ver webSocket.util.js
// import { connectSocket } from "../../utils/webSocket.util.js";
import { inserirCheckpoint } from "../../services/api-planejamento-tributario.service.js";
import Loading from "../../components/Loading/index.js";

const Context = createContext();

function AuthProvider({ children }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [nextLocation, setNextLocation] = useState();
  const [dadosPendentes, setDadosPendentes] = useState();
  const { setDadosLogin } = useContext(LoginContext);

  const handleInserirCheckpoint = useCallback(async () => {
    try {
      if (dadosPendentes) {
        if (dadosPendentes.camposPreenchidos?.dadosTitular?.cnpj) {
          await inserirCheckpoint(dadosPendentes);
        }
      }
    } catch (error) {
      console.log(error?.response?.data);
    } finally {
      setDadosPendentes();
    }
  }, [dadosPendentes]);

  const handleLogout = useCallback(
    async (location) => {
      await handleInserirCheckpoint();
      location ? setNextLocation(location) : setNextLocation();
      setAuthenticated(false);
      AuthServices.logout();
      api.defaults.headers.Authorization = null;
      setDadosLogin({
        status: "",
        email: "",
        tipoCadastroPlanTribKey: "",
        idUsuario: "",
      });
    },
    [handleInserirCheckpoint, setDadosLogin]
  );

  useEffect(() => {
    const onSessionExpired = () => {
      handleLogout();
    };
    window.addEventListener(SESSION_EXPIRED_EVENT, onSessionExpired);
    return () =>
      window.removeEventListener(SESSION_EXPIRED_EVENT, onSessionExpired);
  }, [handleLogout]);

  useEffect(() => {
    const getLogin = async () => {
      try {
        const token = Token.getToken();
        if (token) {
          if (isAccessTokenExpired(token)) {
            AuthServices.logout();
            setAuthenticated(false);
            api.defaults.headers.Authorization = null;
            setDadosLogin({
              status: "",
              email: "",
              tipoCadastroPlanTribKey: "",
              idUsuario: "",
            });
          } else {
            setAuthenticated(true);
            api.defaults.headers.Authorization = `${token}`;
          }
        } else {
          setAuthenticated(false);
          api.defaults.headers.Authorization = null;
          setDadosLogin({
            status: "",
            email: "",
            tipoCadastroPlanTribKey: "",
            idUsuario: "",
          });
        }
        setLoading(false);
      } catch (err) {
        console.log(err);
        AuthServices.logout();
        setAuthenticated(false);
        api.defaults.headers.Authorization = null;
        setDadosLogin({
          status: "",
          email: "",
          tipoCadastroPlanTribKey: "",
          idUsuario: "",
        });
        setLoading(false);
      }
    };
    getLogin();
  }, [setDadosLogin]);

  async function signIn(loginResponse) {
    setAuthenticated(true);
    AuthServices.login(loginResponse);
    api.defaults.headers.Authorization = `${loginResponse.token}`;
    // connectSocket({ idUsuario: loginResponse.usuario.idUsuario });

    const navigateTo = nextLocation || "/dashboard";
    setNavigate(navigateTo);
  }

  return (
    <React.Fragment>
      {loading ? (
        <Loading loading={loading} color="white" />
      ) : (
        <Context.Provider
          value={{ authenticated, signIn, handleLogout, setDadosPendentes }}
        >
          {children}
        </Context.Provider>
      )}
    </React.Fragment>
  );
}

export { Context, AuthProvider };
